







































































































































































import { Component, Vue } from "vue-property-decorator";
import moment from "moment";
@Component({})
export default class FlightMonitor extends Vue {
  mockData: any[] = [];
  headers: any[] = [];
  breadcrumbsItems: any[] = [];
  checkbox: boolean = false;
  isOpenRow: boolean = false;
  items: any[] = [];

  startDate: Date = null;
  startDateMenu: boolean = false;

  endDate: Date = null;
  endDateMenu: boolean = false;

  get getEndDate() {
    return this.endDate ? moment(this.endDate).format("DD-MM-yyyy") : "";
  }

  get getStartDate() {
    return this.startDate ? moment(this.startDate).format("DD-MM-yyyy") : "";
  }

  created() {
    (this.headers = [
      { text: "Kalkış - Varış", value: "destination" },
      { text: "Uçuş Numarası", value: "flightNo" },
      { text: "Havayolu Firması", value: "company" },
      { text: "Kalkış Tarihi", value: "departure" },
      { text: "Uçuş Süresi", value: "flightHour" },
      { text: "Toplam Kota", value: "totalQuota" },
      { text: "Para Birimi", value: "currency" },
      { text: " ", value: "" },
      { text: "", value: "" },
    ]),
      (this.mockData = [
        {
          destination: "AYT-ABA",
          flightNo: "N4 4190",
          company: "NORDWIND",
          departure: "08-06-2021",
          flightHour: "13:00-23:00",
          totalQuota: "10",
          currency: "EUR",
        },
      ]);

    this.breadcrumbsItems = [
      { text: "Ana Sayfa", disabled: false, href: "/#/main/home" },
      { text: "Uçuş", disabled: true },
      { text: "Uçuş Monitörü", disabled: true },
    ];

    this.items = [
      {
        id: 1,
        name: "Antalya",
        children: [
          { id: 2, name: "AYT - ALA" },
          { id: 3, name: "AYT - DME" },
          { id: 4, name: "AYT - MOW" },
        ],
      },

      {
        id: 5,
        name: "Bodrum",
        children: [
          { id: 6, name: "BJV - DME" },
          { id: 7, name: "BJV - HRK" },
          { id: 8, name: "BJV - KBP" },
          { id: 9, name: "BJV - KBP" },
        ],
      },

      {
        id: 10,
        name: "St Petersburg",
        children: [{ id: 11, name: "LED - AER" }],
      },
    ];
  }

  openRow() {
    this.isOpenRow = true;
  }
  closeRow() {
    this.isOpenRow = false;
  }

  data() {
    return {
      page: 1,
    };
  }
}
